/**
 * Query key registry for the replacement data layer.
 * Shapes align with legacy keys during WIRE so React Query caches can be shared.
 */
export const keys = {
  app: {
    config: ['app', 'config'] as const,
    banners: ['banners'] as const,
  },
  customer: (customer_id: number) => ({
    subscription: ['subscription', 'detail', customer_id] as const,
    subscriptionPending: ['pending_subscription', customer_id] as const,
    menu: (date_ymd: string, is_double_box: boolean) =>
      ['menu', customer_id, date_ymd, is_double_box] as const,
    menuAll: ['menu', customer_id] as const,
    /** WIP `foodMenu` module — isolated from stable `menu` keys for exDev A/B. */
    foodMenu: (date_ymd: string, is_double_box: boolean) =>
      ['food-menu', customer_id, date_ymd, is_double_box] as const,
    foodMenuAll: ['food-menu', customer_id] as const,
    calendar: (month_ym: string) => ['calendar', customer_id, month_ym] as const,
    calendarAll: ['calendar', customer_id] as const,
    addresses: ['customer', customer_id, 'addresses'] as const,
    orders: ['customer', customer_id, 'orders'] as const,
    profile: ['customer', customer_id, 'profile'] as const,
    preferences: ['customer', customer_id, 'preferences'] as const,
    notifications: ['notifications', customer_id] as const,
  }),
};

/** Subscription detail key — same shape as legacy `['subscription', 'detail', customer_id]`. */
export function legacySubscriptionKey(customer_id: number) {
  return keys.customer(customer_id).subscription;
}

export function monthFromDateYmd(date_ymd: string): string {
  return date_ymd.length >= 7 ? date_ymd.slice(0, 7) : date_ymd;
}
